import axios from 'axios'
/*
HTTP.interceptors.response.use(
  function onSuccess(response) {
    return response
  },
  function onError(error) {
    // kick back to login on all 401s, unless it's from the login endpoint
    if (error.response.status === 401 && error.config.url !== '/api/login') {
      // window.location = '/'
    }

    return Promise.reject(error)
  }
)
*/
export default new class {
  constructor() {
    this.http = axios.create({
      baseURL: process.env.VUE_APP_API_PATH || '/api'
    })

    this.http.interceptors.response.use(
      function onSuccess(response) {
        return response
      },
      function onError(error) {
        if (error.response.status >= 500) {
          console.error(`Error: ${error.message}:
          URL: ${error.config.method} ${error.config.url}
          response body: ${JSON.stringify(error.response.data, null, 2)}`)
        }
        return Promise.reject(error)
      }
    )
  }

  set authToken(token) {
    this.http.defaults.headers.common['Authorization'] = token
  }

  get() {
    return this.http.get.apply(this.http, arguments)
  }

  post() {
    return this.http.post.apply(this.http, arguments)
  }

  put() {
    return this.http.put.apply(this.http, arguments)
  }

  delete() {
    return this.http.delete.apply(this.http, arguments)
  }

  options() {
    return this.http.options.apply(this.http, arguments)
  }

  head() {
    return this.http.head.apply(this.http, arguments)
  }

  patch() {
    return this.http.patch.apply(this.http, arguments)
  }
}()
